<script>
  import ActionColorShade from "./ActionColorShade.svelte";
  import AccordioItem from "./AccordionItem.svelte";
  import { fade } from "svelte/transition";

  export let groupData = [];
  export let groupName = "";
  export let groupColor = "";

  let isOpen = false;

  const handleOpen = (e) => {
    isOpen = e.detail.isOpen;
  };
</script>

<AccordioItem title={groupName} bgColor={groupColor} on:isOpen={handleOpen}>
  {#if isOpen}
    <div transition:fade class="row-container panel">
      {#each groupData as gd}
        <ActionColorShade color={gd} />
      {/each}
    </div>
  {/if}
</AccordioItem>

<style>
  /* .fade-in{
      opacity: 100%;
      transition:opacity 2s; */
  /* } */
  /* .fade-out{
      opacity: 0%; */
  /* transition:opacity 2s; */
  /* } */
  /* Style the accordion panel. Note: hidden by default */
</style>
